import { connect } from 'react-redux';
import { get } from 'object-path';

import LandingScreen from './LandingScreen';
import { removeInactiveUsers } from '../../helpers/UserUtils';

const mapStateToProps = (state) => {
  return {
    currentUserId: get(state, "identity.id"),
    numPublicChannels: get(Object.keys(state.publicChannels), "length"),
    numUsers: get(Object.keys(removeInactiveUsers(state.users)), "length")
  }
};

export default connect(mapStateToProps)(LandingScreen);
